import exponent from './exponent';

var precisionFixed = function precisionFixed(a) {
  return Math.max(0, -exponent(Math.abs(a)));
};

export default precisionFixed;